import React from 'react';

const ValidationError = ({ children, textSize = 'text-sm' }) => <>
    <div aria-live={'polite'} className={`block mt-2 text-red-600 errors ${textSize}`}>
        { children }
    </div>
</>;

export default ValidationError;
